import React, { useEffect, useState } from 'react'

import { Col, DatePicker, Row } from 'antd'

import { useDispatch, useSelector } from 'react-redux'

import dayjs from 'dayjs'

// Component
import MainHeader from '../components/MainHeader'
import Loader from '../components/Loader'
import PlayerDetailsModal from '../components/modal/PlayerDetailsModal'

import { leagueStart } from '../config/constants'
import { getLeagueRoster } from '../redux/actions/teamActions'
import { openModal } from '../redux/actions/interfaceModalActions'

const LeagueRosters = () => {
  const SETTING = useSelector((state) => state?.user)
  const [date, setDate] = useState(SETTING?.currentDate)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    setIsLoading(true)
    const res = await getLeagueRoster()
    setData(res)
    setIsLoading(false)
  }

  const disabledDate = (current) => {
    const currentDay = dayjs(current)
    const minDate = dayjs(leagueStart)
    const maxDate = dayjs(SETTING.currentDate)
    return currentDay.isBefore(minDate) || currentDay.isAfter(maxDate)
  }

  const filters = [
    {
      name: 'Active',
      color: '#fff',
    },
    {
      name: 'Protected List',
      color: '#0097b2',
    },
    {
      name: 'IR',
      color: '#ff3131',
    },
    {
      name: 'Reserve',
      color: '#7ed957',
    },
    {
      name: 'Waivers',
      color: '#b8a70c',
    },
  ]

  return (
    <div className='lr_container'>
      <MainHeader headingAndDate={false} />

      <div className='heading_header'>
        <h2>League Rosters</h2>
        <div className='date_picker_box' style={{ width: '200px' }}>
          <DatePicker
            inputReadOnly={true}
            placeholder='Select Date'
            value={dayjs(date)}
            onChange={(_, dateString) => {
              setDate(dateString)
            }}
            disabledDate={disabledDate}
          />
        </div>
      </div>

      <div className='filters_section'>
        {filters.map((v) => {
          return (
            <div key={v?.name} className='filter_card'>
              <div className='filter_color' style={{ backgroundColor: v?.color }}></div>
              <p>{v?.name}</p>
            </div>
          )
        })}
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className='lr_card_section'>
          <Row gutter={[20, 20]}>
            {data?.map((v, i) => {
              return (
                <Col key={i} xs={24} lg={12}>
                  <TeamCard data={v} />
                </Col>
              )
            })}
          </Row>
        </div>
      )}
      <PlayerDetailsModal />
    </div>
  )
}

const TeamCard = ({ data }) => {
  const USER = useSelector((state) => state?.user?.userDetails)
  const [extractData, setExtractData] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    const players = data?.squadPlayers
    const obj = {
      centers: players?.filter((v) => v?.player_id?.Position === 'C'),
      wingers: players?.filter(
        (v) => v?.player_id?.Position === 'RW' || v?.player_id?.Position === 'LW',
      ),
      defenders: players?.filter((v) => v?.player_id?.Position === 'D'),
      goalies: players?.filter((v) => v?.player_id?.Position === 'G'),
    }
    setExtractData(obj)
  }, [data])

  const CardBody = ({ title, players, team }) => {
    const getColor = (player) => {
      if (player?.isWaivers) {
        return '#fff'
      } else {
        return '#000'
      }
    }
    const getBgColor = (player) => {
      let color = '#fff'

      const isActive =
        player?.isActive &&
        !player?.inPracticeSquad &&
        !player?.isReserved &&
        !player?.isPlayerInjured &&
        !player?.inWaiver

      if (isActive) {
        color = '#fff'
      } else if (player?.isPlayerInjured) {
        color = '#ff3131'
      } else if (player?.isReserved) {
        color = '#7ed957'
      } else if (player?.inPracticeSquad) {
        color = '#0097b2'
      } else if (player?.inWaiver) {
        color = '#b8a70c'
      }
      return color
    }

    return (
      <div className='card_body'>
        <div className='heading_round_card'>
          <p>{title}</p>
        </div>
        {players?.map((v, i) => {
          const isRoster = {
            playerID: v?.player_id?.PlayerID,
            isReserve: false,
            teamId: null,
            teamName: team?.team?.name ? team?.team?.name : '',
            teamLogo: team?.team?.logo ? team?.team?.logo : null,
            isOwnRoster: {
              status: true,
            },
          }
          const isOtherRoster = {
            playerID: v?.player_id?.PlayerID,
            isReserve: false,
            teamId: team?.teamId ? team?.teamId : null,
            teamName: team?.team?.name ? team?.team?.name : '',
            teamLogo: team?.team?.logo ? team?.team?.logo : null,
          }

          return (
            <div
              key={i}
              className='round_card'
              style={{ backgroundColor: getBgColor(v) }}
              onClick={() => {
                dispatch(
                  openModal(
                    USER?.team?._id === team?.teamId ? { ...isRoster } : { ...isOtherRoster },
                  ),
                )
              }}
            >
              <span className='name_span' style={{ color: getColor(v) }}>
                {`${v?.player_id?.FirstName[0]}. ${v?.player_id?.LastName}`}
              </span>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className='lr_team_card'>
      <div className='card_header'>
        <img src={data?.team?.logo} />
        <p>{data?.team?.name}</p>
      </div>
      <CardBody title={'Centers'} players={extractData?.centers} team={data} />
      <CardBody title={'Wingers'} players={extractData?.wingers} team={data} />
      <CardBody title={'Defenders'} players={extractData?.defenders} team={data} />
      <CardBody title={'Goalies'} players={extractData?.goalies} team={data} />
    </div>
  )
}

export default LeagueRosters
